var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "facebook (1)",
    clipPath: "url(#clip0_12_13999)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M14.3996 28.7992C22.3523 28.7992 28.7992 22.3523 28.7992 14.3996C28.7992 6.44693 22.3523 0 14.3996 0C6.44693 0 0 6.44693 0 14.3996C0 22.3523 6.44693 28.7992 14.3996 28.7992Z",
    fill: "url(#paint0_linear_12_13999)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M20.4214 6.15723H8.37946C7.15273 6.15723 6.1582 7.1517 6.1582 8.37848V20.4204C6.1582 21.6473 7.15268 22.6417 8.37946 22.6417H14.3184L14.3287 16.7512H12.7982C12.5993 16.7512 12.4378 16.5904 12.4372 16.3915L12.4297 14.4926C12.4289 14.2927 12.591 14.1301 12.7908 14.1301H14.3186V12.2954C14.3186 10.1663 15.619 9.00695 17.5183 9.00695H19.0769C19.2762 9.00695 19.438 9.1686 19.438 9.36806V10.9691C19.438 11.1685 19.2764 11.3302 19.0771 11.3302L18.1206 11.3307C17.0877 11.3307 16.8876 11.8215 16.8876 12.5419V14.1303H19.1572C19.3737 14.1303 19.5414 14.3192 19.5158 14.5338L19.2908 16.4327C19.2693 16.6145 19.1152 16.7514 18.9322 16.7514H16.8978L16.8875 22.642H20.4214C21.6481 22.642 22.6426 21.6475 22.6426 20.4207V8.37848C22.6427 7.15176 21.6481 6.15723 20.4214 6.15723Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M14.3183 22.6414L14.3287 16.751H14.3032V22.6414H14.3183Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_12_13999",
    x1: 14.3996,
    y1: 0,
    x2: 14.3996,
    y2: 28.7992,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4E598F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#24306D"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_12_13999"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28.7994,
    height: 28.7994,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.751357414003402535a8f17cd9042dcd.svg";
export { ForwardRef as ReactComponent };